<template>
  <v-dialog
      v-model="dialog"
      persistent
      width="500"
  >

    <template v-slot:activator="{ on }">
      <v-btn
          v-if="mode === 'create'"
          color="primary"
          v-on="on">
        <v-icon>mdi-plus</v-icon>
        Adicionar Tipo de Documento
      </v-btn>
      <v-btn
          v-else
          icon
          v-on="on">
        <v-icon small>mdi-pencil</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title
          class="headline green darken-2 white--text"
          primary-title
      >
        {{dialogTitle()}} Tipo de Documento
      </v-card-title>

      <v-card-text>
        <v-form v-model="valid">

          <v-container>
            <v-layout>
              <v-flex xs4>
                <v-text-field
                    v-model="code"
                    :rules="requiredRules"
                    label="Código"
                    required
                ></v-text-field>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                    v-model="name"
                    :rules="requiredRules"
                    label="Nome"
                    required
                />
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex xs4>
                <v-autocomplete
                    v-model="category"
                    label="Categoria"
                    :items="categories"
                    item-text="name"
                    item-value="value"
                    />

              </v-flex>
              <v-flex xs4>
                <v-text-field
                    v-model="max_size"
                    hint="em MB"
                    :rules="requiredRules"
                    label="Tamanho"
                    required
                />
              </v-flex>
              <v-flex xs4>
                <v-text-field
                    v-model="sub_item"
                    label="Sub-Item"
                    required
                />
              </v-flex>
            </v-layout>
          </v-container>

        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-layout justify-center>
          <v-btn
              :disabled="loading"
              flat
              @click="dialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
              color="primary"
              flat
              :loading="loading"
              :disabled="!valid"
              @click="save()"
          >
            Salvar
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import DocumentTypeService from '@/services/applications/configurations/DocumentTypeService';

  export default {
    name: 'CreateOrUpdate',
    props: ['documentType', 'mode'],
    components: {},
    data() {
      return {
        id: null,
        name: '',
        category: '',
        code: '',
        max_size: '',
        sub_item: '',
        loading: false,
        requiredRules: [
          v => !!v || 'Campo Obrigatório',
        ],
        dialog: false,
        valid: false,
        categories: [
          { name: 'Básico', value: 'basic' },
          { name: 'Específico', value: 'specific' },
          { name: 'Técnico', value: 'technic' }]
      };
    },
    methods: {
      save() {
        const payload = {
          id: this.id,
          name: this.name,
          category: this.category,
          code: this.code,
          max_size: (this.max_size * 1024 * 1024),
          sub_item: this.sub_item,
        };
        DocumentTypeService
          .createOrUpdate(payload)
          .then(() => {
            this.$emit('loadPage');
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'success',
              message: `Tipo de Documento ${this.snackBarMode()} com sucesso`,
              messageIcon: 'mdi-check',
            });
            this.dialog = false;
          })
          .catch(({response}) => {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'error',
              message: response.data.join(', '),
              messageIcon: 'mdi-alert-circle',
            });
          });
      },
      dialogTitle() {
        return this.mode === 'create' ? 'Cadastrar' : 'Editar';
      },
      snackBarMode() {
        return this.mode === 'create' ? 'criado' : 'atualizado';
      }
    },
    watch: {
      dialog(newValue) {
        if (newValue) {
          if (this.documentType !== null) {
            this.id = this.documentType.id;
            this.name = this.documentType.name;
            this.category = this.documentType.category;
            this.code = this.documentType.code;
            this.max_size = (this.documentType.max_size/1024/1024);
            this.sub_item = this.documentType.sub_item;
          }
        }
      },
    }
  };
</script>

<style scoped lang="scss">
</style>
